import { render } from "./Release.vue?vue&type=template&id=242b66be&scoped=true"
const script = {}

import "./Release.vue?vue&type=style&index=0&id=242b66be&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242b66be"]])

export default __exports__